import React, { useState } from "react";
import { TextMessage, VideoMetadata } from "../../../types/chat";
import MediaPreviewModal, { MediaItem } from "../../MediaPreviewModal";
import styles from "./VideoMessage.module.scss";

interface VideoMessageProps {
  message: TextMessage;
  metadata: VideoMetadata;
  isOwnMessage?: boolean;
}

const VideoMessage: React.FC<VideoMessageProps> = ({ message, metadata, isOwnMessage }) => {
  const [showPreview, setShowPreview] = useState(false);

  const handleContainerClick = () => {
    setShowPreview(true);
  };

  const previewItems: MediaItem[] = [
    {
      type: "video",
      url: metadata.attachmentUrl || "",
      thumbnailUrl: metadata.thumbnailUrl,
      name: metadata.name,
      caption: message.content?.message !== metadata.attachmentUrl ? message.content?.message : undefined,
    },
  ];

  return (
    <>
      <div className={styles.videoMessage}>
        <div className={styles.videoContainer} onClick={handleContainerClick} style={{ cursor: "pointer" }}>
          <video
            src={metadata.attachmentUrl}
            poster={metadata.thumbnailUrl}
            className={styles.video}
            preload="metadata"
            onClick={(e) => e.preventDefault()}
          />
          {/* HD Badge */}
          <div className={styles.hdBadge}>HD</div>
        </div>

        {/* Display text content if exists */}
        {message.content?.message && message.content.message !== metadata.attachmentUrl && (
          <div className={`${styles.videoCaption} ${isOwnMessage ? styles.ownMessage : styles.otherMessage}`}>
            {message.content.message}
          </div>
        )}
      </div>

      <MediaPreviewModal isOpen={showPreview} onClose={() => setShowPreview(false)} items={previewItems} />
    </>
  );
};

export default VideoMessage;
